<template>
  <div class="mobile-header px-3">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="position-relative side-nav-main me-3">
          <img
            v-if="userID"
            @click="showsidebar = !showsidebar"
            src="@/assets/newimg/certificates/sidebarOpen.svg"
            alt=""
          />
          <div
            class="mh-side-nav"
            @focusout="showsidebar = false"
            :class="{ mhfixedwidth: showsidebar, mhtrans: !showsidebar }"
          >
            <div class="mh-side-menu-main">
              <ul class="list-unstyled">
                <li
                  @click="switchToCandidate('homepage')"
                  class="d-flex align-items-center mh-inactivenavclass-back"
                >
                  <img
                    class="ms-2"
                    src="@/assets/sidebar/mobDashInact.svg"
                    alt=""
                  />
                  <span id="workBench">Home</span>
                </li>

                <li
                  @click="switchToCandidate('dashboard')"
                  class="d-flex align-items-center mh-inactivenavclass-back"
                >
                  <img
                    class="ms-2 mr-1"
                    src="@/assets/sidebar/mob-Resumebuilder-Unsel.svg"
                    alt=""
                  />
                  <span id="workBench">Resume Builder</span>
                </li>

                <li
                  @click="switchToCandidate('assessment/categories')"
                  class="d-flex align-items-center mh-inactivenavclass-back"
                >
                  <img
                    class="ms-2"
                    src="@/assets/sidebar/mobAsmntInact.svg"
                    alt=""
                  />
                  <span
                    id="workBench"
                    @click="switchToCandidate('assessment/categories')"
                    class="d-flex align-items-center"
                  >
                    Assessment Progress</span
                  >
                </li>

                <li
                  style="width: 93%"
                  class="pointer mh-inactivenavclass-dropdown"
                >
                  <div
                    class="d-flex align-items-center justify-content-between w-100"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        class="me-1"
                        src="@/assets/sidebar/Training-Sel.svg"
                        alt=""
                      />

                      <span id="workBench" style="margin-left: -6px"
                        >Training</span
                      >
                    </div>
                    <img src="@/assets/sidebarUpArrow.svg" alt="" />
                    <!-- <img v-else src="@/assets/sidebardownarrow.svg" alt="" /> -->
                  </div>
                  <b-collapse v-model="showTraining">
                    <div class="ms-2 mt-3 ps-3">
                      <div
                        :class="
                          checkCurrentRoute('MarketPlace')
                            ? 'mh-selected-suboption'
                            : 'mh-unselected-suboption'
                        "
                        @click="openRoute('MarketPlace')"
                      >
                        <div
                          v-if="checkCurrentRoute('MarketPlace')"
                          class="sel-line-sidebar"
                        ></div>
                        Market place
                      </div>
                      <div
                        :class="
                          checkCurrentRoute('Dashboard')
                            ? 'mh-selected-suboption'
                            : 'mh-unselected-suboption'
                        "
                        @click="openRoute('Dashboard')"
                      >
                        <div
                          v-if="checkCurrentRoute('Dashboard')"
                          class="sel-line-sidebar"
                        ></div>
                        Dashboard
                      </div>
                      <div
                        :class="
                          checkCurrentRoute('CommunityView')
                            ? 'mh-selected-suboption'
                            : 'mh-unselected-suboption'
                        "
                        @click="openRoute('CommunityView')"
                      >
                        <div
                          v-if="checkCurrentRoute('CommunityView')"
                          class="sel-line-sidebar"
                        ></div>
                        Community
                      </div>
                      <div
                        :class="
                          checkCurrentRoute('Certificate')
                            ? 'mh-selected-suboption'
                            : 'mh-unselected-suboption'
                        "
                        @click="openRoute('Certificate')"
                      >
                        <div
                          v-show="checkCurrentRoute('Certificate')"
                          class="sel-line-sidebar"
                        ></div>
                        Certificates
                      </div>
                    </div>
                  </b-collapse>
                </li>

                <li style="width: 93%" class="mh-inactivenavclass-dropdown">
                  <div
                    class="d-flex align-items-center justify-content-between w-100"
                    @click="openjoboptions = !openjoboptions"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        class="mr-1 ms-2"
                        src="@/assets/sidebar/mobjobUnsel.svg"
                        alt=""
                      />
                      <span> Jobs</span>
                    </div>
                    <img
                      v-if="openjoboptions"
                      src="@/assets/sidebar/sidebarUpArrow.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="@/assets/sidebar/sidebardownarrow.svg"
                      alt=""
                    />
                  </div>
                  <b-collapse v-model="openjoboptions">
                    <div class="ms-3 mt-3 ps-3">
                      <div
                        class="mh-unselected-suboption"
                        @click.stop="switchToCandidate('job/search')"
                      >
                        Job Search
                      </div>
                      <div
                        class="mh-unselected-suboption"
                        @click.stop="
                          switchToCandidate('job/progress?from=sidebar')
                        "
                      >
                        Applied Jobs
                      </div>
                      <div
                        class="mh-unselected-suboption"
                        @click.stop="
                          switchToCandidate(
                            'job/search?bookmarked=true&from=sidebar'
                          )
                        "
                      >
                        Saved Jobs
                      </div>
                    </div>
                  </b-collapse>
                </li>

                <li
                  @click="switchToCandidate('documents')"
                  class="d-flex align-items-center mh-inactivenavclass-back"
                >
                  <img
                    class="ms-2"
                    src="@/assets/sidebar/mobDocInact.svg"
                    alt=""
                  />
                  <span id="workBench"> Upload Documents</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="d-flex" style="margin-top:3px;">
          <img src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg" alt="" />
        </div>
      </div>
      <div v-if="userID" class="d-flex align-items-center">
        <div>
          <img
            src="@/assets/sidebar/blueProfile.svg"
            alt=""
            @click="openCandidate"
          />
        </div>
        <div class="ms-3 position-relative">
          <div class="user-image-header">
            <img
              class="w-100 h-100"
              @click="showsignout = !showsignout"
              :src="userData && userData.image ? userData.image : ''"
              alt=""
            />
          </div>
          <div v-if="showsignout" class="mb-header-box">
            <div class="mb-header-name">
              <img
                class="me-1 mb-profile-pic-2"
                :src="userData && userData.image ? userData.image : ''"
                alt=""
              />

              {{ fullName }}
            </div>
            <div class="mb-resume-name-2 d-flex align-items-center my-3">
              <img class="me-1" src="@/assets/mb-settings.svg" alt="" />
              Account Settings
            </div>
            <div class="d-flex align-items-center pointer">
              <img class="me-2" src="@/assets/Help copy.svg" alt="" />
              <div class="mb-resume-name-2">Help</div>
            </div>
            <div class="demograpgic-data"></div>
            <div
              @click="logout"
              class="d-flex align-items-center justify-content-center mt-2 mb-blue-txt-3"
            >
              <img class="me-1" src="@/assets/mb-signout.svg" alt="" />
              Log Out
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex mt-2" v-else>
        <div class="newoutline log-header">
          <b-button
            @click="openLogin"
            class="btn search-btn cl-btn btn-secondary w-post-btn"
            >Log in</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProcessedToken } from "@/utils/request";
import header from "@/views/mixin/header";
import { mapGetters } from "vuex";
import { getInfo, staticImage } from "../Dashboard/api-client/dashboard";

export default {
  mixins: [header],
  data() {
    return {
      showTraining: true,
      userData: {},
      openjoboptions: false,
      showsidebar: false,
      showsignout: false,
      userID: null,
      baseUrl: "https://candidate.hire3x.com/builder/",
    };
  },
  async created() {
    this.userID = getProcessedToken();
    try {
      const response = await getInfo();
      this.userData = response.data.data;
      if (
        !this.userData.image &&
        this.userData.firstName &&
        this.userData.firstName.length &&
        this.userData.lastName &&
        this.userData.lastName.length
      ) {
        const imageData = await staticImage(
          this.userData.firstName[0] + this.userData.lastName[0]
        );
        this.userData.image = imageData.data.data.link;
      }
      console.log("in header", this.userData);
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    // Attach a click event listener to the document body
    document.body.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove the click event listener when the component is destroyed
    document.body.removeEventListener("click", this.handleClickOutside);
  },
  computed: {
    fullName() {
      if (this.userData && Object.keys(this.userData).length) {
        return `${this.userData.firstName} ${this.userData.lastName}`;
      }
      return "";
    },
  },
  methods: {
    openLogin() {
      window.open("https://app.hire3x.com/login", "_self");
    },
    openSignUp() {
      window.open("https://app.hire3x.com/register", "_self");
    },
    logout() {
      this.$store.dispatch("userVUEX/LogOut");
    },
    openCandidate() {
      window.open(
        "https://candidate.hire3x.com/builder/myprofile",
        "_self"
      );
    },
    pushPage(name) {
      this.$router.push({
        name,
      });
    },
    switchToCandidate(path) {
      window.open(this.baseUrl + path, "_self");
    },
    handleClickOutside(event) {
      // Check if the click event occurred outside of the sidebar
      const sidebar = document.querySelector(".side-nav-main");
      if (sidebar && !sidebar.contains(event.target)) {
        // If the click is outside the sidebar, close it
        this.showsidebar = false;
      }
    },
  },
};
</script>

<style>
.user-image-header {
  overflow: hidden;
  height: 40px;
  width: 40px;
  border-radius: 50%;
background: rgba(114, 115, 142, 0.05);
}
.mh-side-nav {
  position: fixed;
  top: 0%;
  left: 0;
  background: #fcfcfc;
  width: 0px;
  border-radius: 0px;
  /* height: calc(100dvh - 7%); */
  height: 100vh;
  box-shadow: 9px 4px 13px 0px #0000001a;

  z-index: 15;
  overflow: hidden;
}

.mh-side-menu-main li img {
  padding-right: 10px;
  cursor: pointer;
}

.mh-side-menu-main {
  padding-left: 0px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100dvh - 145px);
}

.mh-side-menu-main ul li {
  margin: 12px 12px;
  white-space: nowrap;
  position: relative;
}

.mh-activenavclass {
  color: #324054 !important;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
}
.mh-inactivenavclass {
  color: #324054 !important;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.mh-activenavclass-back {
  background-color: #eef3f7;
  border-radius: 4px;
  padding: 7px 8px;
}
.mh-inactivenavclass-back {
  background-color: transparent;
  border-radius: 15px;
  padding: 7px 8px;
}

.mh-activenavclass-dropdown {
  background-color: transparent;
  border-radius: 4px;
  padding: 7px 8px;
  color: #20639b !important;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
}
.mh-inactivenavclass-dropdown {
  background-color: transparent;
  border-radius: 15px;
  padding: 7px 8px;
  color: #324054 !important;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.mh-jobs-sidebar-cont {
  border-left: 2px solid #8c8c8c8c;
}

.mh-selected-suboption {
  background: #20639b14;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #20639b;
  border-radius: 4px;
  padding: 7px 10px;
  margin: 2px 0;
  position: relative;
}

.mh-unselected-suboption {
  background: transparent;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #344054;
  border-radius: 4px;
  padding: 7px 10px;
  margin: 2px 0;
}

.mhfixedwidth {
  width: 225px !important;
}
.mhtrans {
  transition: width 1s;
}

.mb-profile-pic-2 {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 1px solid #ffffff;
}

.mb-header-box {
  position: absolute;
  background-color: #ffffff;
  box-shadow: 0px 1px 11px 0px #00000061;
  border-radius: 4px;
  width: 250px;
  z-index: 5;
  right: 0px;
  top: 45px;
  padding: 10px 14px;
}

.mb-header-name {
  background-color: #20639b;
  border-radius: 5px;
  color: #ffffff;
  padding: 5px;
  font-size: 16px;
  font-weight: 500;
  font-family: "lato", sans-serif;
}

.mb-resume-name-2 {
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #3a3c40;
}

.hoverclass:hover {
  background: #e8eff4;
  padding: 0.25rem !important;
}

.demograpgic-data {
  width: 100%;
  height: 1px;
  background-color: rgba(140, 140, 140, 0.33);
  margin-top: 9px;
}

.mb-blue-txt-3 {
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #20639b;
}
.mobile-header {
  box-shadow: 0px 4px 4px 0px #00000014;
  padding: 10px;
  height: 60px;
  background: #ffffff;
}
.log-header button:hover {
  background: #ffffff !important;
  color: #20639b !important;
  border: 1px solid#20639b !important;
}
</style>
